import { render, staticRenderFns } from "./nbn-realized-service.vue?vue&type=template&id=0968f6c8&scoped=true"
import script from "./nbn-realized-service.vue?vue&type=script&lang=js"
export * from "./nbn-realized-service.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0968f6c8",
  null
  
)

export default component.exports